/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Purge_Email_Records_SystemInputs */

const en_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your email address (plus any record of past purchases / trials) will be purged from our system`)
};

const id_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email Anda (serta catatan pembelian / uji coba sebelumnya) akan dihapus dari sistem kami.`)
};

const ms_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat emel anda (serta sebarang rekod pembelian / percubaan lepas) akan dipadam dari sistem kami`)
};

const ca_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La teva adreça de correu electrònic (a més de qualsevol registre de compres/passos anteriors) serà eliminada del nostre sistema.`)
};

const cs_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše emailová adresa (plus jakýkoliv záznam o minulých nákupech / zkušebních verzích) budou z našeho systému odstraněny.`)
};

const da_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din e-mailadresse (samt enhver registrering af tidligere køb/prøver) vil blive fjernet fra vores system`)
};

const de_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre E-Mail-Adresse (plus alle Aufzeichnungen über frühere Käufe/Versuche) wird aus unserem System gelöscht`)
};

const et_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie e-posti aadress (ja kõik varasemate ostude/katseliste salvestused) kustutatakse meie süsteemist`)
};

const es_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu dirección de correo electrónico (más cualquier registro de compras anteriores/pruebas) se eliminará de nuestro sistema`)
};

const fr_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre adresse e-mail et l’historique de vos achats et périodes d’essai effectuées seront effacés de notre système.`)
};

const hr_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaša e-mail adresa (plus bilo koji zapis o prošlim kupnjama / probama) bit će izbrisana iz našeg sustava.`)
};

const it_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo indirizzo email (oltre a qualsiasi registrazione di acquisti passati/prove) verrà eliminato dal nostro sistema.`)
};

const lv_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu e-pasta adrese (un jebkurš iepriekšējo pirkumu / izmēģinājumu ieraksts) tiks dzēsta no mūsu sistēmas.`)
};

const lt_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsų el. paštas (ir bet kokie ankstesnių pirkimų/bandytojų įrašai) bus pašalinti iš mūsų sistemos`)
};

const hu_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az e-mail címe (és bármilyen korábbi vásárlási/kísérleti rekord) törlésre kerül a rendszerünkből`)
};

const nl_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je e-mailadres (plus eventuele gegevens van eerdere aankopen/proefperiodes) wordt uit ons systeem verwijderd.`)
};

const nb_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postadressen din (pluss eventuelle registreringer av tidligere kjøp/prøveperioder) slettes fra systemet vårt`)
};

const pl_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój adres e-mail (oraz wszelkie zapisy zakupów/okresów próbnych) zostaną usunięte z naszego systemu`)
};

const pt_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu endereço de e-mail (mais qualquer registro de compras passadas/testes) será apagado do nosso sistema.`)
};

const ro_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa dvs. de e-mail (plus orice înregistrare de achiziții/pregătiri anterioare) va fi eliminată din sistemul nostru.`)
};

const sk_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaša e-mailová adresa (plus akékoľvek záznamy o minulých nákupoch / skúšobných verziách) budú odstránené z nášho systému`)
};

const sl_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaš e-poštni naslov (vključno z vsemi evidencami preteklih nakupov / poskusov) bo izbrisan iz našega sistema.`)
};

const fi_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköpostiosoitteesi (sekä kaikki tiedot aiemmista ostoista/kokeiluista) poistetaan järjestelmästämme.`)
};

const sv_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din e-postadress (samt alla poster över tidigare köp/provperioder) kommer att raderas från vårt system`)
};

const vi_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ email của bạn (cộng với bất kỳ bản ghi mua hàng / thử nghiệm nào trong quá khứ) sẽ bị xóa khỏi hệ thống của chúng tôi`)
};

const tr_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresiniz (ve geçmişteki satın alma/kullanım kayıtları) sistemimizden silinecek.`)
};

const el_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η διεύθυνση email σας (μαζί με οποιοδήποτε αρχείο παρελθοντικών αγορών/δοκιμών) θα διαγραφεί από το σύστημά μας`)
};

const bg_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вашият имейл адрес (плюс всякакви записи за минали покупки/пробни периоди) ще бъде изтрит от нашата система.`)
};

const ru_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш адрес электронной почты (а также все записи о прошлых покупках/испытаниях) будут удалены из нашей системы.`)
};

const sr_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша имејл адреса (плус било који запис о претходним куповинама/пробама) биће обрисани из нашег система`)
};

const uk_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша адреса електронної пошти (а також будь-який запис про минулі покупки / пробні періоди) буде видалено з нашої системи.`)
};

const ka_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენი მეილის მისამართი (და ნებისმიერი წარსული შესყიდვები/ცდების ჩანაწერები) წაიშლება ჩვენს სისტემაში.`)
};

const hi_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका ईमेल पता (साथ ही पूर्व खरीदारियों / परीक्षणों का कोई भी रिकॉर्ड) हमारे सिस्टम से हटा दिया जाएगा`)
};

const th_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่อยู่อีเมลของคุณ (และบันทึกการซื้อ/ทดลองที่ผ่านมาทั้งหมด) จะถูกลบออกจากระบบของเรา`)
};

const ko_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소(이전 구매/평가판 기록 포함)가 시스템에서 삭제됩니다.`)
};

const zh_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的电子邮件地址（以及任何过往购买/试用记录）将会从我们的系统中清除`)
};

const zh_tw_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的電子郵件地址（以及任何過往購買／試用紀錄）將從我們的系統中清除。`)
};

const ja_purge_email_records_system = /** @type {(inputs: Purge_Email_Records_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス（および過去の購入/トライアルの記録）がシステムから削除されます`)
};

/**
* | output |
* | --- |
* | "Your email address (plus any record of past purchases / trials) will be purged from our system" |
*
* @param {Purge_Email_Records_SystemInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const purge_email_records_system = /** @type {((inputs?: Purge_Email_Records_SystemInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Purge_Email_Records_SystemInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_purge_email_records_system(inputs)
	if (locale === "ms") return ms_purge_email_records_system(inputs)
	if (locale === "ca") return ca_purge_email_records_system(inputs)
	if (locale === "cs") return cs_purge_email_records_system(inputs)
	if (locale === "da") return da_purge_email_records_system(inputs)
	if (locale === "de") return de_purge_email_records_system(inputs)
	if (locale === "et") return et_purge_email_records_system(inputs)
	if (locale === "es") return es_purge_email_records_system(inputs)
	if (locale === "fr") return fr_purge_email_records_system(inputs)
	if (locale === "hr") return hr_purge_email_records_system(inputs)
	if (locale === "it") return it_purge_email_records_system(inputs)
	if (locale === "lv") return lv_purge_email_records_system(inputs)
	if (locale === "lt") return lt_purge_email_records_system(inputs)
	if (locale === "hu") return hu_purge_email_records_system(inputs)
	if (locale === "nl") return nl_purge_email_records_system(inputs)
	if (locale === "nb") return nb_purge_email_records_system(inputs)
	if (locale === "pl") return pl_purge_email_records_system(inputs)
	if (locale === "pt") return pt_purge_email_records_system(inputs)
	if (locale === "ro") return ro_purge_email_records_system(inputs)
	if (locale === "sk") return sk_purge_email_records_system(inputs)
	if (locale === "sl") return sl_purge_email_records_system(inputs)
	if (locale === "fi") return fi_purge_email_records_system(inputs)
	if (locale === "sv") return sv_purge_email_records_system(inputs)
	if (locale === "vi") return vi_purge_email_records_system(inputs)
	if (locale === "tr") return tr_purge_email_records_system(inputs)
	if (locale === "el") return el_purge_email_records_system(inputs)
	if (locale === "bg") return bg_purge_email_records_system(inputs)
	if (locale === "ru") return ru_purge_email_records_system(inputs)
	if (locale === "sr") return sr_purge_email_records_system(inputs)
	if (locale === "uk") return uk_purge_email_records_system(inputs)
	if (locale === "ka") return ka_purge_email_records_system(inputs)
	if (locale === "hi") return hi_purge_email_records_system(inputs)
	if (locale === "th") return th_purge_email_records_system(inputs)
	if (locale === "ko") return ko_purge_email_records_system(inputs)
	if (locale === "zh") return zh_purge_email_records_system(inputs)
	if (locale === "zh-tw") return zh_tw_purge_email_records_system(inputs)
	if (locale === "ja") return ja_purge_email_records_system(inputs)
	return en_purge_email_records_system(inputs)
});